"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuiteLocalStorageService = exports.authSuiteLocalStorageService = void 0;
var window_service_1 = require("../service/window-service");
var models_1 = require("./models");
var getLocalStorage = function () {
    return window_service_1.windowService.getWindow().localStorage;
};
var addPrefix = function (key) { return "".concat(models_1.AuthSuitePrefixes.LocalStoragePrefix).concat(key); };
var getItem = function (key) {
    var prefixedKey = addPrefix(key);
    return getLocalStorage().getItem(prefixedKey);
};
var removeItem = function (key) {
    var prefixedKey = addPrefix(key);
    getLocalStorage().removeItem(prefixedKey);
};
var setItem = function (key, value) {
    var prefixedKey = addPrefix(key);
    getLocalStorage().setItem(prefixedKey, value);
};
exports.authSuiteLocalStorageService = {
    getItem: getItem,
    removeItem: removeItem,
    setItem: setItem,
};
var AuthSuiteLocalStorageService = /** @class */ (function () {
    function AuthSuiteLocalStorageService() {
        return exports.authSuiteLocalStorageService;
    }
    return AuthSuiteLocalStorageService;
}());
exports.AuthSuiteLocalStorageService = AuthSuiteLocalStorageService;
